// Layout
const dashboardLayout = () => import('@/layouts/DriverLayout/DashboardLayout/dashboardLayout.vue')

const support = () => import('./views/index')

// start Routes
export default [
  {
    path: '/driver/support',
    component: dashboardLayout,
    children: [
      {
        path: '',
        name: 'driverSupport',
        meta: {
          name: 'driverSupport',
          parentName: 'marketplace',
          userType: '',
          permission: '',
          role: 'transportation.driver'
        },
        component: support
      }
    ]
  }
]
